import { Box } from '@/components/ui/box'
import { getInfoIcon } from '@/store/tasksApprovals/utils'
import { TWidgetStatus } from '@/types/tasksApprovals'

const InfoIcon = ({
    days,
    isMobile = false,
    isSelected,
    status,
}: {
    days: number | null
    isMobile?: boolean
    isSelected: boolean
    status?: TWidgetStatus
}) => {
    if (!days) return null

    const baseStyles = {
        width: '13px',
        height: '13px',
    }
    const mobileStyles = {
        position: 'absolute',
        top: '5px',
        left: '5px',
        width: '13px',
        height: '13px',
    }

    let styles = { ...baseStyles }
    if (isMobile) {
        styles = {
            ...baseStyles,
            ...mobileStyles,
        }
    }

    const icon = getInfoIcon(days, status ?? 'waiting', isSelected)

    return icon && <Box style={styles}>{icon}</Box>
}

export default InfoIcon
